<!--
 * @Author: likk 1126919170@qq.com
 * @Date: 2024-04-23 18:55:13
 * @LastEditors: likk 1126919170@qq.com
 * @LastEditTime: 2024-05-11 19:56:25
 * @FilePath: /m-ai.nongji360.com/src/views/Spark/components/NoCountBar.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="bar">
		<span><router-link to="/login" class="btn-text">登录</router-link>后，可以问我</span>
    <img class="icon" src="@/assets/images/spark/audio_icon.png"/>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		}
	}
</script>

<style lang="scss" scoped>
	.bar{
		z-index: 999;
		position: fixed;
		left: 50%;
		bottom: 33px;
		transform: translateX(-50%);
		width: 345px;
		height: 48px;
		padding: 0 15px;
		box-sizing: border-box;
		border-radius: 11px;
		box-shadow: 0px 1px 18px rgba(0,0,0,0.12);
		background: #ffffff;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 17px;
		color: #9A9A9A;
		.btn-text{
			color: #7FBE26;
		}
		.icon{
			width: auto;
			height: 22px;
		}
	}
</style>